var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFpsQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36454",
    "data-name": "Group 36454",
    transform: "translate(-3.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39819",
    "data-name": "Path 39819",
    d: "M9,4H5A1,1,0,0,0,4,5V9a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V5A1,1,0,0,0,9,4Z",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39820",
    "data-name": "Path 39820",
    d: "M7,17v.01",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39821",
    "data-name": "Path 39821",
    d: "M19,4H15a1,1,0,0,0-1,1V9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5A1,1,0,0,0,19,4Z",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39822",
    "data-name": "Path 39822",
    d: "M7,7v.01",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39823",
    "data-name": "Path 39823",
    d: "M9,14H5a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V15A1,1,0,0,0,9,14Z",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39824",
    "data-name": "Path 39824",
    d: "M17,7v.01",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39825",
    "data-name": "Path 39825",
    d: "M14,14h3",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39826",
    "data-name": "Path 39826",
    d: "M20,14v.01",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39827",
    "data-name": "Path 39827",
    d: "M14,14v3",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39828",
    "data-name": "Path 39828",
    d: "M14,20h3",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39829",
    "data-name": "Path 39829",
    d: "M17,17h3",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39830",
    "data-name": "Path 39830",
    d: "M20,17v3",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpsQr);
export default __webpack_public_path__ + "static/media/fps-qr.c0f3e1e667bf5a89b2a9d265e5abed45.svg";
export { ForwardRef as ReactComponent };